import { ROUTE_USER_IN_DCF } from '../constants/system-external-events';

/**
 * Creates message for visa-sdk with ROUTE_USER_IN_DCF event.
 *
 * In certain flows we will launch the app for the purposes of showing the app loader.
 * This is used after app instantiation when System SDK knows the user needs to be routed
 to a specific DCF screen.
 * The app will use this message to set remaining app state and route user to the appropriate screen.
 *
 * @param {Object?} data
 * @returns {Object} message
 */
const getRouteUserInDCFMessage = data => {
  return {
    data,
    type: ROUTE_USER_IN_DCF
  };
};

export default getRouteUserInDCFMessage;
